import axios from 'axios';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { EducationLevelCatalogResponse } from 'src/types/educationLevel.types';
import { Country } from 'src/types/country';
import { queryKeys } from 'src/queries/keys';

export const educationLevelsQueryOptions = (
  country?: Country,
): UseQueryOptions<EducationLevelCatalogResponse> => ({
  queryKey: queryKeys.educationLevels(country),
  queryFn: async () => {
    const { data } = await axios.get<EducationLevelCatalogResponse>(
      '/api/education-levels',
      { params: country ? { country } : {} },
    );
    return data;
  },
  staleTime: 60 * 60 * 1000,
  refetchOnWindowFocus: false,
  enabled: !!country,
});

export const useEducationLevels = (
  country?: Country,
): UseQueryResult<EducationLevelCatalogResponse> =>
  useQuery<EducationLevelCatalogResponse>(educationLevelsQueryOptions(country));
